<script>
	import {API,http_headers} from '../global.js'
    import FormasPago from '../cliente/formas-pago.svelte'

	export let pagoid
	
	 $: refresh = async()=>{
		let res = await fetch(`${API}/ventas-by-id/${pagoid}`)
		const ds = await res.json()
        
        ds.data.comisiones = JSON.parse(ds.data.comisiones)
        ds.data.fichasocio = JSON.parse(ds.data.fichasocio)
        ds.data.planpagos = JSON.parse(ds.data.planpagos)
       // console.log(ds)
		return ds.data || []
	}

	let formaPagoOn = false
    let cobranza = {}

	function setCobranza(cb){
        cobranza = cb
        formaPagoOn = true
    }
</script>

<div class="container">
	{#await refresh()}
		<p>Loading...</p>
	{:then rs}
		
		<div class="row mt-4 ">
			<div class="col-12"><h3>{rs.tipo} - {rs.producto}</h3></div>
		</div>
		<div class="row mt-4">
			<div class="col"><h4>Total de su transaccion : {rs.planpagos.moneda} {rs.planpagos.importeVenta.toFixed(2)}</h4></div>
			<div class="col-4">
				<button class="btn btn-danger btn-lg" 
					on:click={()=>setCobranza({
                                                idcliente : rs.idcliente,
                                                importe : rs.planpagos.importeVenta.toFixed(2), 
                                                idmoneda:1, 
                                                simbolo:rs.planpagos.moneda,
                                                tipocli:'',
                                                sociedad:'0',
                                                idcomplejo:'0',
                                                complejo: 'V-'+rs.tipo+' '+ rs.producto ,
                                                cobranza: 'V-'+rs.tipo
                                    })}>Ver Opciones para pago
				</button>
            </div>
		</div>
		
		{#if rs.planpagos.cuotasAnticipo.length}
			<div class="row border-bottom mt-4"><div class="col"><b>Anticipo</b></div></div>
			<div class="row border-bottom">
				{#each rs.planpagos.cuotasAnticipo as ca, index}
					<div class="col-4">{ca.cuota}</div>
					<div class="col-4">{ca.fecha}</div>
					<div class="col-4">{ca.importe}</div>
				{/each}
			</div>
		{/if}
		{#if rs.planpagos.cuotasSaldo.length}
			<div class="row mt-4"><div class="col"><b>Saldo</b></div></div>
			<div class="row">
				{#each rs.planpagos.cuotasSaldo as cs, index}
					<div class="col-4">{cs.cuota}</div>
					<div class="col-4">{cs.fecha}</div>
					<div class="col-4">{cs.importe}</div>
				{/each}
			</div>
		{/if}
		
		<div class="row mt-4">
			<div class="col-12"><b>Detalles<b></div>
			<div class="col-12">
				<textarea class="form-control" value={rs.observ} rows=10 readonly></textarea>
			</div>
		</div>
<!--
		<pre>{JSON.stringify(rs,null,2)}</pre>
-->		
		
	{/await}
</div>


{#if formaPagoOn}
    <div class="overlay">
        <!--button class="btn btn-danger float-end m-2" id on:click={()=>formaPagoOn=false} ><b>&Cross;</b></button-->
        <FormasPago {cobranza} on:close={()=>formaPagoOn=false}/> 
    </div>
{/if}
